// v2/components/ScrollToTop.js — sayfa degisince en basa don
// Sadece YOL degisiminde calisir: ProductsV2 filtreleri query string'i
// guncelledigi icin arama parametreleri haric tutulur (yoksa her filtre
// tiklamasinda sayfa yukari firlar).
// Geri/ileri (POP) ile gelindiginde tarayicinin konumu korumasina dokunulmaz.
import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const tip = useNavigationType();          // PUSH | REPLACE | POP
  const onceki = useRef(null);

  useEffect(() => {
    if (onceki.current === pathname) return;   // ayni sayfa, sadece filtre degisti
    onceki.current = pathname;
    if (tip === 'POP') return;                 // geri/ileri: konum korunsun
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, tip]);

  return null;
}
